import { Component, OnInit } from '@angular/core';
import { UserProfileState } from '@state/user-profile';
import { ICON } from '@core/util/icon';
import { MatDialog } from '@angular/material/dialog';
import { AuthUser } from '@state/auth/auth.models';
import { SelectSnapshot, ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { AuthState } from '@state/auth';
import { ViewTeranetAccountComponent } from './credentials/teranet-credentials.component';
import { Observable } from 'rxjs';
import { BusinessAddress } from '@models/businesses';
import { BusinessDispatch, BusinessState } from '@state/business';
import {
	BusinessAddressesDispatch,
	BusinessAddressesState,
} from '@state/business/address';
import { Select } from '@ngxs/store';
import { SnackbarService } from '@services/ui/snackbar.service';
import { Form, NgForm } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { cloneDeep } from 'lodash';

@UntilDestroy()
@Component({
	selector: 'app-profile-teranet',
	templateUrl: './teranet.component.html',
	styleUrls: ['./teranet.component.scss'],
	standalone: false,
})
export class ProfileTeranetComponent implements OnInit {
	public ICON = ICON;
	public loginModalOpen = false;

	public benefits = [
		'Access the Electronic Land Registration Database and Writs Database without leaving Closer',
		'Sync fields from search results directly with Closer, reducing errors and saving time',
		'Sync title and writ search fees incurred directly with your Statement of Account',
	];

	@SelectSnapshot(AuthState.getLoggedInUser) loggedInUser: AuthUser;
	@ViewSelectSnapshot(UserProfileState.getTeranetUsername)
	teranetUsername: string;
	@Select(BusinessState.getTeranetAccountName)
	teranetAccountName$: Observable<string>;
	@Select(BusinessAddressesState.getAll) addresses$: Observable<
		BusinessAddress[]
	>;

	constructor(
		private dialog: MatDialog,
		private businessDispatch: BusinessDispatch,
		private businessAddressDispatch: BusinessAddressesDispatch,
		private snackbarService: SnackbarService,
	) {}

	viewCredentials(): void {
		if (!this.loginModalOpen) {
			this.dialog.open(ViewTeranetAccountComponent, {
				maxWidth: '600px',
				width: '100%',
			});
		}
	}

	public integrationsForm: Form;
	public teranetFormValue = 'teranetAccountName';
	public teranetAccountName;
	public addresses;
	public showOverrides = false;

	ngOnInit(): void {
		this.teranetAccountName$
			.pipe(untilDestroyed(this))
			.subscribe((value) => (this.teranetAccountName = value));

		this.addresses$.pipe(untilDestroyed(this)).subscribe((value) => {
			this.addresses = cloneDeep(value);
		});

		this.showOverrides = this.addresses.some(
			(x) => x.teranetAccountName?.length > 0,
		);
	}

	onSubmit(form: NgForm) {
		if (form.invalid) {
			this.snackbarService.openSnackBar({
				text: 'Please make sure to fill out your account name.',
				type: 'error',
			});

			return;
		}

		this.businessDispatch.SetTeranetAccountName(this.teranetAccountName);

		const updatedAddresses: Partial<BusinessAddress[]> =
			this.addresses?.map((x) => {
				const result: Partial<BusinessAddress> = {
					id: x.id,
					teranetAccountName:
						this.showOverrides && x?.teranetAccountName
							? x?.teranetAccountName
							: null,
				};

				return result;
			}) ?? [];

		if (updatedAddresses?.length > 0) {
			this.businessAddressDispatch.UpdateAll(updatedAddresses);
		}

		this.snackbarService.openSnackBar({
			text: 'Teranet account name saved.',
			type: 'success',
		});
	}
}
